import React, { useEffect } from 'react';
import { CustomInputProps } from './types/CustomInputsTypes';

const CustomTextInput: React.FC<CustomInputProps> = ({
  label,
  name,
  value,
  defaultValue,
  onChange,
  placeholder = '',
  maxLength = 10000,
  error,
  required = false,
  description,
  className = '',
  width = 'w-[350px]',
  isEditable = true,
  // isLockedByMe,
  // lockedOwner,
  isReviewForm,
  onFocus,
}) => {
  // Track if the default value has been set already
  useEffect(() => {
    if (defaultValue && !value && onChange) {
      onChange({
        target: { name, value: defaultValue } as EventTarget & HTMLInputElement,
      } as React.ChangeEvent<HTMLInputElement>);
    }
  }, [defaultValue, value, name, onChange]);

  return (
    <div>
      <label className={`mt-4 text-ds-gray-700 font-semibold block label-text `}>
        {label}
        {required && <span className="text-ds-red-400"> *</span>}
      </label>

      {description && <p className="mt-1 text-xs text-ds-gray-300">{description}</p>}

      <div className="relative h-full py-2">
        <input
          type="text"
          name={name}
          value={value ?? ''}
          onChange={onChange}
          disabled={!isEditable || isReviewForm}
          className={`
            h-[40px]
            ${width}
            rounded-md
            px-2
            text-xs
            text-ds-gray-500
            outline-none
            placeholder:text-ds-gray-300
            placeholder:text-xs
            ${!isEditable || isReviewForm ? 'bg-ds-gray-50 border-none' : error ? 'border-2 border-ds-red-400' : 'border-2 border-ds-gray-100'}
            ${className}
          `}
          placeholder={placeholder}
          maxLength={maxLength}
          onFocus={onFocus}
        />
        {error && <p className="w-[360px] pt-1 text-xs font-normal text-ds-red-400">{error}</p>}
      </div>
    </div>
  );
};

export default CustomTextInput;
